import React from 'react'
import style from './style.module.scss'
import { motion } from 'framer-motion'
import { useMediaQuery } from '../../../hooks/useMediaQuery'

type ExternalsTopHeaderParams = {
    externals: { ticketting: string; myHand: string; handballTV: string; handHome: string }
}

const ExternalsTopHeader: React.FC<ExternalsTopHeaderParams> = ({ externals }) => {
    const mobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')
    const { ticketting, myHand, handballTV, handHome } = externals

    const variants = {
        open: {
            transition: { staggerChildren: 0.1, delayChildren: 1 },
        },
        closed: {
            transition: { staggerChildren: 0.1, staggerDirection: -1 },
        },
    }

    const itemVariants = {
        open: {
            y: 0,
            opacity: 1,
            transition: {
                y: { stiffness: 1000, velocity: -100 },
            },
        },
        closed: {
            y: 50,
            opacity: 0,
            transition: {
                y: { stiffness: 1000 },
            },
        },
    }

    return (
        <motion.div
            className={style.externals}
            variants={mobile ? variants : undefined}
            initial="closed"
            animate="open"
            exit="closed"
        >
            {handHome && (
                <motion.a
                    href={handHome}
                    target={'_blank'}
                    rel={'noreferrer'}
                    variants={mobile ? itemVariants : undefined}
                >
                    <i className="fi fi-rs-home"></i>
                    <span>MAISON DU HANDBALL</span>
                </motion.a>
            )}
            {ticketting && (
                <motion.a
                    href={ticketting}
                    target={'_blank'}
                    rel={'noreferrer'}
                    variants={mobile ? itemVariants : undefined}
                >
                    <i className="fi fi-rs-ticket"></i>
                    <span>BILLETTERIE</span>
                </motion.a>
            )}
            {myHand && (
                <motion.a
                    href={myHand}
                    target={'_blank'}
                    rel={'noreferrer'}
                    variants={mobile ? itemVariants : undefined}
                >
                    <i className="fi fi-rs-volleyball"></i>
                    <span>MyHAND</span>
                </motion.a>
            )}
            {handballTV && (
                <motion.a
                    href={handballTV}
                    target={'_blank'}
                    rel={'noreferrer'}
                    variants={mobile ? itemVariants : undefined}
                >
                    <i className="fi fi-rs-play-alt"></i>
                    <span>HANDBALLTV</span>
                </motion.a>
            )}
        </motion.div>
    )
}

export default ExternalsTopHeader
